import { useTranslation } from 'react-i18next';
import moment from 'moment/min/moment-with-locales';
import { useFundraisingStatus } from '@/hooks/shared/useFundraisingStatus';
import { DATE_FORMAT_DD_MMMM, DATE_FORMAT_MMMM_YYYY } from '@/helpers/common';
import { FPG_ASSETS_STATUS } from '@/helpers/constants';
import { prettyFloatMoney } from '@/helpers/utils';
import { prettyDate } from '@/helpers/date';
import { FR_STEPS } from '@/helpers/fundraising';
import { APP_LINKS } from '@/helpers/links';
import { InfoMessage } from '@/components/InfoMessage';
import s from './index.module.scss';

export const DashboardMessages = () => {
  const { t } = useTranslation('dashboard');
  const { data: status, isParticipating } = useFundraisingStatus();

  if (!status || !isParticipating) return null;

  let message = null;

  if (status.fpg_assets_status === FPG_ASSETS_STATUS.rejected && status.is_participating) {
    message = (
      <InfoMessage
        type="action"
        title={t('dashboard_messages.update_option_choice')}
        description={t('dashboard_messages.unable_to_approve_free_option')}
        linkUrl={APP_LINKS.fundraising}
        linkState={{ step: 'fpg_select' }}
        linkLabel={t('dashboard_messages.select_option')}
      />
    );
  }

  if (status.step === FR_STEPS.set_goal) {
    message = (
      <InfoMessage
        type="action"
        title={t('dashboard_messages.set_new_goal', {
          date: moment(status.end_date).subtract('1', 'day').format(DATE_FORMAT_DD_MMMM),
        })}
        linkUrl={APP_LINKS.fundraising}
        linkLabel={t('dashboard_messages.set_fundraising_goal')}
      />
    );
  }

  if (status.step === FR_STEPS.fundraising_summary && status.goal) {
    message = (
      <InfoMessage
        type="info"
        title={t('dashboard_messages.your_fundraising_goal', {
          date: prettyDate(status.start_date, DATE_FORMAT_MMMM_YYYY),
          goal: prettyFloatMoney(status.goal),
        })}
      />
    );
  }

  if (status.fpg_assets_status === FPG_ASSETS_STATUS.review && status.is_participating) {
    message = (
      <InfoMessage
        type="info"
        title={t('dashboard_messages.application_pending_review')}
        description={t('dashboard_messages.documents_under_review')}
      />
    );
  }

  if (!message) return null;

  return <div className={s.wrapper}>{message}</div>;
};
